import React, { Component } from 'react';
import { Link } from 'react-router';
import AppStore from '../../stores/app-store.js'
import './Terminar.css';
import '../../grid.css';

class Terminar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            legendas: AppStore.legendas,
        }
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    componentWillMount() {
        AppStore.addChangeLinguaListener(this.onChangeLingua);
    }

    componentWillUnmount() {
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
    }


    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }

    render() {
        return (
            <div className="Terminar">
                <h2>{this.state.legendas.desejaGuardar}</h2>
                <div className="ui-g">
                    <div className="ui-g-6">
                        <Link to="/capa" style={{ fontFamily: 'OpenSans', fontSize: '36px', padding: '10px', color: 'white' }}>{this.state.legendas.sim}</Link>
                    </div>
                    <div className="ui-g-6">
                        <Link to="/capa" style={{ fontFamily: 'OpenSans', fontSize: '36px', padding: '10px', color: 'white' }}>{this.state.legendas.nao}</Link>
                    </div>
                </div>

            </div>
        );
    }
}

export default Terminar;


// WEBPACK FOOTER //
// ./src/componentes/terminar/Terminar.js